const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/pages/$pageId/edit.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { LOCALES } from "@/lib/locale";
export const Route = createFileRoute("/dashboard/admin/pages/$pageId/edit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});